import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'gps.alerts.edit.fields.eventTypeLabel' }),
    infoText: translate({ id: 'gps.alerts.edit.fields.eventTypeDescription' }),
  }))

  return api
}
